const { useLocation } = require("react-router-dom");
import React from "react";
export const useQuery = queryStr => {
  return new URLSearchParams(queryStr);
};
